<template>
  <div>
    <canvas :id="canvasID" height="500" width="400"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js'


export default {
  name: "SleepChart",
  props: [ 'chartLabel','studentSleepData', 'firstRedSlot', 'firstYellowSlot', 'greenSlot', 'secondRedSlot', 'secondYellowSlot','canvasID','chartTitle','chartMin'],
  data: function () {
    return {
      planetChartData: {

        type: 'line',
        data: {
          labels: this.chartLabel,
          datasets: [{
            backgroundColor: '#8057EF',
            borderColor: '#8057EF',
            showLine: true,
            fill: false,
            data: this.studentSleepData,
          }, {
            backgroundColor: 'rgba(255,1,1,0.25)',
            borderWidth: 1,
            showLine: true,
            borderColor: '#ff0000',
            fill: true,
            data: this.firstRedSlot,

          }, {
            backgroundColor: 'rgba(255,248,0,0.3)',
            borderWidth: 1,
            showLine: true,
            borderColor: '#fff900',
            fill: +2,
            data: this.firstYellowSlot,

          }, {
            backgroundColor: 'rgba(49,246,5,0.3)',
            borderWidth: 1,
            showLine: true,
            borderColor: '#4df605',
            fill: 2,
            data: this.greenSlot,

          }, {
            backgroundColor: 'rgba(255,248,0,0.3)',
            borderWidth: 1,
            showLine: true,
            borderColor: '#fff900',
            fill: +1,
            data: this.secondYellowSlot,

          }, {
            backgroundColor: 'rgba(255,1,1,0.25)',
            borderWidth: 1,
            showLine: true,
            borderColor: '#ff0000',
            fill: +1,
            data: this.secondRedSlot,

              legend: {
                display: false,

              }

          }]
        },
        options: {
          title: {
            display: true,
            text: this.chartTitle,
          },
          responsive: true,
          legend: {
            display: false,
            position: 'top',
            rtl: true,
            labels: {
              color: 'rgb(255, 99, 132)'
            }
          },
          scales: {
            xAxes: [{
              display: true,
            }],
            yAxes: [{
              display: true,
              ticks: {
                min: this.chartMin,
                stepSize: 1
              }
            }]
          }

        },
      }
    }
  },
  mounted() {
    Chart.defaults.global.defaultFontFamily = "IRANSans";
    const ctx = document.getElementById(this.canvasID);
    new Chart(ctx, this.planetChartData);
  }

}
</script>

<style scoped>

</style>
